import { AddLocationComponent } from "./add-location/add-location.component";
import { EditLocationComponent } from "./edit-location/edit-location.component";
import { ViewLocationComponent } from "./view-location/view-location.component";


export const LocationRouting = [
    { path: '', redirectTo: 'view-location', pathMatch: 'full' },
    { path: 'view-location', component: ViewLocationComponent },
    { path: 'add-location', component: AddLocationComponent },
    { path: 'edit-location/:locationID', component: EditLocationComponent },

];
export const LocationRoutingBreadcrumbs = [
    { name: 'Edit', path: '/edit-location' },
    { name: 'Add', path: '/add-location' },
];